import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHomeData } from "../../redux/actions/dataActions";

import "./Banner.css";
import Trucks from "./Trucks.js";
import track from "../../assets/images/isuzutrack.png";
import logo from "../../assets/images/isuzulogo.png";
import geelytrack from "../../assets/images/geelytrack.png";
import geelylogo from "../../assets/images/geelylogo.png";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

function Banner(props) {
  
  const { orders } = useSelector((state) => state.data);
  const { data } = useSelector((state) => state.data);

  const [orderIndex, setOrderIndex] = useState(-1);
  const [clickedOrder, setClickedOrder] = useState(false);
  const [disableLeft, setDisableLeft] = useState(true);
  const [disableRight, setDisableRight] = useState(true);

  const dispatch = useDispatch();

  const changeOrder = (Docnum) => {
    dispatch(getHomeData(Docnum))
  };

  const nextOrder = () => {
    setOrderIndex(orderIndex+1);
    setClickedOrder(true);
  }

  const prevOrder = () => {
    setOrderIndex(orderIndex-1);
    setClickedOrder(true);
  }

  useEffect(() => {
    if (orderIndex === -1 && orders.length > 0 && data) {
      let key = orders.findIndex(order => order.Docnum === data?.id || order.Docnum === data?.LicNum);

      setOrderIndex(key);

      setDisableLeft(key === orders.length - 1);
      setDisableRight(key === 0);

    }
  }, [orders])

  useEffect(() => {
    if (orders) {
      let key = orders.findIndex(order => order.Docnum === data?.LicNum || order.Docnum === data?.id);
      setOrderIndex(key);
      setDisableLeft(key === orders.length - 1);
      setDisableRight(key === 0);
    }
  }, [data])

  useEffect(() => {

    if (clickedOrder) {
      
      if (orderIndex > -1 && orders.length > 0) {
        let docNum = orders[orderIndex]?.Docnum;

        if (docNum) {
          changeOrder(docNum);
        }
        setClickedOrder(false);

        // set arrows
        setDisableLeft(orderIndex === orders.length - 1);
        setDisableRight(orderIndex === 0);
      }
      
    }
  }, [clickedOrder])
  return (
    <div dir="rtl" className="width-100">
      <Trucks changeOrder={changeOrder}/>
      <div dir="rtl" className="second-banner">
        <div className="text-area">
          <span className="first-title">קניתם איסוזו חדשה?</span>
          <span className="title">תתחדשו!</span>
        </div>
        <div className="text-area text_area_left">
          <div className="bold">היי {props?.customerName},</div>
          <span>
            בנינו איזור אישי שבו תוכלו להתעדכן בסטטוס ההזמנה שלכם, ולראות את
            התהליך שהרכב שלכם עובר
          </span>
        </div>
      </div>
      <div className="third-banner">
        {orders && orders.length > 1 && (
          <div className="trucks-counter">
            <span className="trucks-counter-left">{orderIndex == -1 ? orderIndex+2 : orderIndex+1}</span>/{orders.length}
          </div>
        )}
        <div className={`red-banner banner_${props.brand}`}>
          {orders && orders.length > 1 ? (
            <>
            <div className={"arrow-left" + (disableLeft ? " arrow-disabled" : "")} onClick={nextOrder}>
              <FaAngleLeft className={disableLeft ? " arrow-rect-disabled" : "arrow-rect"}/>
            </div>
            <div className={"arrow-right" + (disableRight ? " arrow-disabled" : "")} onClick={prevOrder}>
              <FaAngleRight className={disableRight ? " arrow-rect-disabled" : "arrow-rect"}/>
            </div>
            </>
          ) : ''}
          <div className="isuzu-track">
            {props.brand&&<img src={props.brand=='ISUZU'?track:geelytrack}></img>}
          </div>
          <div className="isusu-logo-wrap">{props.brand&&<img className="isusu-logo" src={props.brand=='ISUZU'?logo:geelylogo} />}</div>
          <div className="truck-details-wrap">
            <div className="truck-details">
              <div className="deal-type"> 
                {props.type === 'NewCar' ? 'רכב חדש' : 'ליסינג'} 
              </div>
              {data?.truckData?.licNum &&
                <div className="lic-text">
                  {data?.truckData?.licNum}
                </div>
              }
            </div>  
            <div className="details bold">{props.modelName}</div>
            <div className="details">{props.orderType}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
